import React from 'react';
import { Copy, Edit2, Printer } from 'lucide-react';

import { DemoBanner } from './DemoBanner';

export function ClientProfile() {
  return (
    <div className="space-y-4">
      <DemoBanner section="Профиль клиента" />

      <div className="bg-white border border-gray-200 rounded-xl px-[20px] py-[10px]">
        <div className="flex items-center justify-between mb-4 pb-3 border-b border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900">Профиль клиента</h3>
          <div className="flex items-center gap-3">
            <button className="flex items-center gap-1.5 text-xs text-gray-400 hover:text-gray-700" type="button">
              <Edit2 size={12} /> Редактировать
            </button>
            <button className="flex items-center gap-1.5 text-xs text-gray-400 hover:text-gray-700" type="button">
              <Printer size={12} /> Печать
            </button>
            <button className="flex items-center gap-1.5 text-xs text-gray-400 hover:text-gray-700" type="button">
              <Copy size={12} /> Копировать
            </button>
          </div>
        </div>

        <div className="mb-1" />
      </div>

      <div className="bg-white border border-gray-200 rounded-xl p-5">
        <h4 className="font-semibold text-gray-900 text-sm mb-3">Потенциальные диагнозы МКБ-10</h4>
        <div className="border border-gray-100 rounded-lg overflow-hidden text-sm">
          {[
            [
              'Код МКБ-10',
              'F43.23',
            ],
            [
              'Название',
              'Расстройство адаптации со смешанной тревогой и депрессией',
            ],
            [
              'Обоснование',
              'Симптомы тревоги и вины, связанные с работой и отношениями. Трудности с самопомощью. Симптомы возникают в ответ на идентифицируемые стрессоры.',
            ],
          ].map(([label, value], i) => (
            <div key={i} className={`flex gap-3 px-4 py-2.5 ${i < 2 ? 'border-b border-gray-100' : ''}`}>
              <span className="w-32 shrink-0 font-medium text-gray-600 text-xs">{label}</span>
              <span className="text-gray-700 text-xs">{value}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl p-5">
        <h4 className="font-semibold text-gray-900 text-sm mb-3">История клиента</h4>
        <div className="space-y-2 text-xs text-gray-700 leading-relaxed">
          <p>26-летний предприниматель, владелец малого бизнеса. Диагноз: ГТР. Пережил эмоциональное пренебрежение в детстве — отец ушёл из семьи, мать была эмоционально недоступна.</p>
          <p>Дефицит постоянной привязанности сформировал паттерны перфекционизма ради избегания отвержения. Трудности с некомпетентным ассистентом и баланс работы/жизни.</p>
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl p-5">
        <h4 className="font-semibold text-gray-900 text-sm mb-3">Цели терапии</h4>
        <ul className="space-y-1.5 text-xs text-gray-700">
          {[
            'Снижение симптомов тревоги и уровня стресса',
            'Развитие навыков самосострадания и самоотношения',
            'Улучшение навыков установления здоровых границ',
            'Проработка детских паттернов привязанности',
          ].map((goal, i) => (
            <li key={i} className="flex items-start gap-2">
              <span className="text-amber-400 mt-0.5">•</span>
              <span>{goal}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

